import React from 'react'

export default function Skills(){
   return (
     <div className="skills-details">
       <div className="skill">
         <div className="skill-name">Back-End</div>
         <div className="skill-progress-bar">
           <div style={{width: "85%",background: "#39FF14"}} className="skill-progress"></div>
         </div>
       </div>
       <div className="skill">
         <div className="skill-name">Front-End</div>
         <div className="skill-progress-bar">
           <div style={{width: "70%",background: "#2192FF"}} className="skill-progress"></div>
         </div>
       </div>
       <div className="skill">
         <div className="skill-name">PHP</div>
         <div className="skill-progress-bar">
           <div style={{width: "90%",background: "#4F5B93"}} className="skill-progress"></div>
         </div>
       </div>
       <div className="skill">
         <div className="skill-name">Magento</div>
         <div className="skill-progress-bar">
           <div style={{width: "90%",background: "#F26322"}} className="skill-progress"></div>
         </div>
       </div>
     </div>
  );
}
